// components/ui/ActionButton.jsx
import React from 'react';

const ActionButton = ({ 
  onClick, 
  color = 'blue', 
  icon, 
  title, 
  size = 'sm',
  disabled = false 
}) => {
  const colorClasses = {
    blue: 'bg-blue-100 hover:bg-blue-200 text-blue-600',
    green: 'bg-green-100 hover:bg-green-200 text-green-600',
    purple: 'bg-purple-100 hover:bg-purple-200 text-purple-600',
    orange: 'bg-orange-100 hover:bg-orange-200 text-orange-600',
    red: 'bg-red-100 hover:bg-red-200 text-red-600',
    gray: 'bg-gray-100 hover:bg-gray-200 text-gray-600'
  };

  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${sizeClasses[size]} 
        rounded-full 
        flex items-center justify-center 
        transition-colors 
        ${disabled ? 'opacity-50 cursor-not-allowed' : colorClasses[color]}
      `}
      title={title}
    >
      {icon}
    </button>
  );
};

export default ActionButton;